<template>
  <div
      class="tw-grid tw-grid-cols-2 tw-justify-between tw-py-3 order-item-not-last">
    <div class="tw-flex tw-items-center">
      <img class="tw-rounded tw-mr-3 tw-shadow" width="52px" height="52px" :src="element.artwork" />
      <div class="tw-flex tw-flex-col tw-truncate">
        <span class="tw-text-infinity-primary-text tw-font-medium tw-truncate">{{ element.name }}</span>
        <span v-if="type === 'beat' || type === 'soundkit' || type === 'service'|| type === 'service_quote'" class="tw-text-xs tw-text-infinity-tertiary-text tw-truncate">
            <template v-if="type === 'beat'">
              {{ element.license }}
            </template>
            <template v-else-if="type === 'soundkit'">
              {{ element.pricing_name }}
            </template>
            <template v-else-if="['service', 'service_quote'].includes(type)">
                  <div class="tw-flex tw-space-x-3">
                    <div
                        v-for="item in [{
                            icon: ['far', 'clock'],
                            label: getServiceDeliveryLabel()
                        },
                        {
                            icon: 'repeat',
                            label: element.revisions + ' Revisions'
                            }
                        ]"
                        class="tw-transition tw-flex tw-items-center tw-text-infinity-tertiary-text tw-text-xxs tw-font-light">
                        <font-awesome-icon :icon="item.icon" class="tw-mr-1" />
                        {{ item.label }}
                    </div>
                </div>
            </template>
          </span>
        <template v-if="type === 'collection' || type === 'beattapes'">
            {{ `${element.itemsCount} Beats` }}
        </template>
      </div>
    </div>
    <div class="tw-flex tw-items-center tw-flex-wrap tw-justify-end">
      <order-item-button v-if="element.contract_download_url"
                         :href="element.contract_download_url"
                         is-contract
                         :label="['soundkit', 'service', 'service_quote'].includes(type) ? 'Agreement' : 'Contract'" />
      <order-item-button v-if="element.trackout_download_url"
                         :href="element.trackout_download_url"
                         label="TRACKOUT" />
      <order-item-button v-if="element.wav_download_url"
                         :href="element.wav_download_url"
                         label="WAV" />
      <order-item-button v-if="element.mp3_download_url"
                         :href="element.mp3_download_url"
                         label="MP3" />
      <order-item-button v-if="element.zip_download_url"
                         :href="element.zip_download_url"
                         :icon="['fas','download']"
                         label="ZIP" />
        <service-item-button v-if="element.buyer_instructions"
                             :title="element.name"
                             :instructions="element.buyer_instructions"  />
        <button v-show="showViewFilesButton"  @click="showBeatTapeModal" class="c-button c-button--shrinked tw-m-1 c-button--default">
              View beats
      </button>
    </div>
  </div>
</template>
<script>
import OrderItemButton from "./order-item-button";
import Service from "../../models/service";
import ServiceItemButton from "./service-item-button";

export default {
  components: { ServiceItemButton, OrderItemButton },
  props: {
    element: Object,
    type: String,
  },
  methods: {
      getServiceDeliveryLabel() {
          return Service.getDeliveryLabel(this.element.delivery_time)
      },
    showBeatTapeModal() {
        const name = this.element.name
        const id = this.element.id
        const items = this.element.items
        this.$modal.show("beat-tape-items", { name: name, id: id, items: items })
    },
  },
  computed: {
    showViewFilesButton() {
      return (this.type === 'beattapes' || this.type === 'collection')  && this.element.itemsCount
    }
  }
};
</script>
<style lang="scss">
.order-item-not-last {
  &:not(:last-child) {
    @apply tw-border-b tw-border-0 tw-border-solid tw-border-infinity-primary-text-faded-more;
  }
}
</style>
